import { render, staticRenderFns } from "./studenthik.vue?vue&type=template&id=9b63635a&scoped=true&"
import script from "./studenthik.vue?vue&type=script&lang=js&"
export * from "./studenthik.vue?vue&type=script&lang=js&"
import style0 from "./studenthik.vue?vue&type=style&index=0&id=9b63635a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b63635a",
  null
  
)

export default component.exports